module.exports = __webpack_public_path__ + "img/app-default-img.255ed3af.png";